export default __webpack_public_path__ + "331afad4eaaa81197dca7a5369bc69f1.png";